const tagType = {
  ACCESSIBILITY: 'accessibility',
  LOCATION_TYPE: 'location_type',
};

export default tagType;
